export default function Checkbox({ label, value, handleClick }) {
  return(
    <label className="flex items-center gap-4">
      <input
        className="w-5 h-5 rounded-lg accent-gray-500"
        type="checkbox"
        checked={value}
        onChange={(e) => handleClick(e.target.checked)}
      />
      {label}
    </label>
  )
}